import { resolveImageUrl } from './utils';

export function buildRegenerateUrlParams(image: { params?: Record<string, any> }): URLSearchParams {
  const imgParamsForUrl = image.params || {};
  const isPackshot =
    imgParamsForUrl.mockup === 'product_packshot' || imgParamsForUrl.sceneType === 'product_packshot';

  let imageStyle = 'photo';
  if (isPackshot) {
    imageStyle = 'packshot';
  } else if (imgParamsForUrl.imageStyle) {
    imageStyle = imgParamsForUrl.imageStyle;
  }

  const urlParamsObj = new URLSearchParams();
  urlParamsObj.set('imageStyle', imageStyle);

  const sceneType = imgParamsForUrl.mockup || imgParamsForUrl.sceneType;
  if (sceneType) urlParamsObj.set('sceneType', sceneType);
  if (imgParamsForUrl.location) urlParamsObj.set('location', imgParamsForUrl.location);

  const aspectRatio = imgParamsForUrl.aspectRatio || imgParamsForUrl.aspect_ratio;
  if (aspectRatio) urlParamsObj.set('aspectRatio', aspectRatio);

  const people = imgParamsForUrl.people || imgParamsForUrl.people_mode;
  if (people) urlParamsObj.set('people', people);

  const peopleGender = imgParamsForUrl.peopleGender || imgParamsForUrl.people_gender;
  if (peopleGender) urlParamsObj.set('peopleGender', peopleGender);

  const peopleEthnicity = imgParamsForUrl.peopleEthnicity || imgParamsForUrl.people_ethnicity;
  if (peopleEthnicity) urlParamsObj.set('peopleEthnicity', peopleEthnicity);

  const peopleAge = imgParamsForUrl.peopleAge || imgParamsForUrl.people_age;
  if (peopleAge) urlParamsObj.set('peopleAge', peopleAge);

  if (imgParamsForUrl.device) urlParamsObj.set('device', imgParamsForUrl.device);

  const packshotStyle = imgParamsForUrl.packshotStyle || imgParamsForUrl.packshot_style;
  if (packshotStyle) urlParamsObj.set('packshotStyle', packshotStyle);

  if (imgParamsForUrl.template) urlParamsObj.set('template', imgParamsForUrl.template);

  return urlParamsObj;
}

export function resolveRegenerateImageUrl(image: { params?: Record<string, any>; url: string }): string {
  let imageUrl = image.params?.referenceImageUrl || image.url;
  return imageUrl.startsWith('http') || imageUrl.startsWith('data:')
    ? imageUrl
    : resolveImageUrl(imageUrl);
}
